/* eslint-disable no-unused-vars */
import "./auth.css";
// import "../../assets/css/style.css";
import React from "react";
// import logo from "../../assets/images/logo.svg";
// import logo from "../../assets/images/landbook.png";
// import logoText from "../../assets/images/logo-text.svg";
// Error Message
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const notify = () =>
  toast.error("Invalid User", {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

const auth = ({ title, children, AuthCustomStyle }) => {
  return (
    <>
      <div>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          limit={1}
        />
      </div>
      <div className="login-page-container">
        <div className="container">
          <div className="row justify-content-center h-100 align-items-center">
            <div className="col-10">
              <div className="authincation-content">
                <div className={`row no-gutters ${AuthCustomStyle}`}>
                  <div className="login col-xl-6 col-xxl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="cover-photo"></div>
                  </div>
                  <div className="auth-content col-xl-6 col-xxl-6 col-lg-12 col-md-12 col-sm-12">
                    <div className="auth-form">
                      <div className="login-logo">
                        {/* <img className="brand-logo mb-5" src={logo} alt="" /> */}
                        {/* <img
                          className="brand-title mb-5"
                          src={logoText}
                          width="160px"
                          alt=""
                        /> */}
                      </div>
                      {children}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default auth;
